const STREAM_CODE_MASK = 0x6a09e667;

export function streamDetailsPath(id: number, suffix = ''): string {
    if (!Number.isSafeInteger(id) || id < 1 || id > 0xffffffff) return `/leadstream/${id}${suffix}`;
    const code = ((id ^ STREAM_CODE_MASK) >>> 0).toString(36).padStart(7, '0');
    return `/leadstream/s-${code}${suffix}`;
}

export function streamIdFromPath(value: string): number | null {
    if (/^[1-9]\d*$/.test(value)) {
        const id = Number(value);
        return Number.isSafeInteger(id) ? id : null;
    }
    if (!/^s-[0-9a-z]{7}$/.test(value)) return null;
    const masked = Number.parseInt(value.slice(2), 36);
    if (!Number.isSafeInteger(masked) || masked > 0xffffffff) return null;
    const id = (masked ^ STREAM_CODE_MASK) >>> 0;
    return id > 0 && streamDetailsPath(id).endsWith(value) ? id : null;
}
